module.exports = __webpack_public_path__ + "static/media/original-logo.332f2e2c.png";